import { render, staticRenderFns } from "./Return_product_waitupdate.vue?vue&type=template&id=1e4ae6ed&scoped=true&"
import script from "./Return_product_waitupdate.vue?vue&type=script&lang=js&"
export * from "./Return_product_waitupdate.vue?vue&type=script&lang=js&"
import style0 from "./Return_product_waitupdate.vue?vue&type=style&index=0&id=1e4ae6ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ae6ed",
  null
  
)

export default component.exports